import React, { useMemo, useState } from "react";
import ProfileContainer from "../components/ProfileContainer";
import NEWSkillFormButton from "../components/NEWSkillFormButton";
import AIIcon from "../../../components/AiIcon";

const MAX_LENGTH = 20;

const TalentProfileSkills = ({ items, criteria = {}, ...props }) => {
    const [isMoreOpen, setIsMoreOpen] = useState(false);


    const skills = useMemo(() => {
        let allSkills = items;
        let criteriaSkills = criteria?.skills || [];
        TB.map(TB.values(laravel.importance_levels), imp => {
            if (criteria?.[`${TB.snakeCase(imp)}_skills`]?.length > 0) {
                criteriaSkills = [...criteriaSkills, ...criteria[`${TB.snakeCase(imp)}_skills`]]
            }
        })
        if (criteriaSkills && criteriaSkills.length > 0) {
            let matchSkillIds = TB.map(criteriaSkills, 'id');
            allSkills = TB.map(allSkills, ind => {
                return {
                    ...ind,
                    isMatch: matchSkillIds.includes(ind.id),
                }
            });
            allSkills = TB.orderBy(allSkills, 'isMatch', 'desc')
        }
        return allSkills;
    }, [items, criteria?.skills])

    const hasMatchingSkills = useMemo(() => {
        return TB.filter(skills, ['isMatch', true])?.length > 0;
    }, [skills]);

    const hasAiSkills = useMemo(() => {
        return skills.some(skill => skill?.category === 1)
    }, [skills]);

    return (
        <div id="skills" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <div className="flex flex-row items-start justify-between pb-6">
                        <div className="flex items-center gap-8">
                            <h4 className="textbold text-lg">
                                Skills {!!skills.length && `(${skills.length})`}
                            </h4>
                            {hasMatchingSkills && (
                                <div className="flex flex-row items-center gap-1.5 justify-end">
                                    <div className="h-2 w-2 rounded-full bg-wripplePrimaryPaleGreen" />
                                    <span className="text-xs italic">
                                        Indicates Match
                                    </span>
                                </div>
                            )}
                        </div>
                        <div>
                            {hasAiSkills && (
                                <div className="flex flex-row items-center gap-1.5 justify-end">
                                    <AIIcon className="inline -mt-[4px] fill-wripplePrimaryMediumBlue" size={26} fill={null} />
                                    <span className="text-xs italic">
                                        Indicates AI Skill
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                    {!skills.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Skills Available</p>
                        </div>
                    )}


                    <div className="flex gap-4 flex-wrap">
                        {skills?.slice(0, isMoreOpen ? skills?.length : MAX_LENGTH).map(skill => {
                            return (
                                <NEWSkillFormButton
                                    key={skill.id}
                                    readonly
                                    skill={skill}
                                    match={skill.isMatch}
                                    scoringOptions={skill.category ? laravel.talent_scoring_options_by_category[skill.category] : laravel.talent_scoring_options}
                                    type={skill.category ? 'info' : 'default'}
                                />
                            )
                        })}
                    </div>

                    {skills.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                onClick={() => setIsMoreOpen(!isMoreOpen)}
                            >
                                <p>{skills.length - MAX_LENGTH} {isMoreOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isMoreOpen })} />
                                </div>
                            </button>
                        </div>
                    )}

                </div>
            </ProfileContainer>
        </div>
    )
}

export default TalentProfileSkills;